import React from 'react';
import { tdToast } from 'utils/ToastUtils/toast';
import i18n from 'i18n';
import { useAppNotification } from 'domains/user/model/selectors';
import { TGroup } from 'types/general';
import { toastSuccessBold } from 'utils/ToastUtils/toastBold';
import { Link } from 'react-router-dom';

export const toastErrorCopy = (): void => {
  const isAppNotification = useAppNotification();
  if (isAppNotification) {
    tdToast('ERROR', i18n.t(`campaigns_page.campaigns_copy_modal.unknow_error`))
  }
};

const getI18keyForCopyAlert = (manyCamp: boolean, manyClients: boolean) => {
  if (manyCamp && manyClients)
    return 'campaigns_page.campaigns_copy_modal.many_camps_copy_many_clients';
  if (manyCamp && !manyClients)
    return 'campaigns_page.campaigns_copy_modal.many_camps_copy_one_client';
  if (!manyCamp && manyClients)
    return 'campaigns_page.campaigns_copy_modal.one_camp_copy_many_clients';
  return 'campaigns_page.campaigns_copy_modal.one_camp_copy_one_client';
};

type TFToastSuccessCopy = (
  from: TGroup,
  to: TGroup,
  isAppNotification: boolean,
) => void;
export const toastSuccessCopy: TFToastSuccessCopy = (
  from,
  to,
  isAppNotification,
) => {
  if (isAppNotification) {
    const manyCamp = from.length > 1;
    const manyClients = to.length > 1;
    const i18key = getI18keyForCopyAlert(manyCamp, manyClients);
    const titles = from.map((campaign) => campaign.title).join(', ');

    toastSuccessBold(
      i18key,
      {
        titles,
      },
      {
        clients: (
          <span>
            {to.map((e, index) => (
              <>
                <Link
                  to={`/main/campaigns?client_id=${e.xxhash}`}
                  key={e.xxhash}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <strong>{e.title}</strong>
                </Link>
                {to.length - 1 !== index && <span>, </span>}
              </>
            ))}
          </span>
        ),
      },
    );
  }
};

const getI18keyForDoubleAlert = (manyCamp: boolean) => {
  if (!manyCamp) return 'campaigns_page.campaigns_copy_modal.one_camp_double';
  return 'campaigns_page.campaigns_copy_modal.many_camp_double';
};

type TFToastSuccessDoubled = (
  from: TGroup,
  to: string[],
  isAppNotification: boolean,
) => void;

export const toastSuccessDoubled: TFToastSuccessDoubled = (
  from,
  to,
  isAppNotification,
) => {
  if (isAppNotification) {
    const manyCamp = from.length > 1;
    const i18key = getI18keyForDoubleAlert(manyCamp);
    const titles = from.map((campaign) => campaign.title).join(', ');

    toastSuccessBold(
      i18key,
      {
        titles,
      },
      {
        clients: (
          <span>
            {to.map((e, index) => (
              <>
                <Link
                  to={`/main/campaign/${e}/main`}
                  key={e}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <strong>{`${from[index]?.title} copy`}</strong>
                </Link>
                {to.length - 1 !== index && <span>, </span>}
              </>
            ))}
          </span>
        ),
      },
    );
  }
};
